module.exports = __webpack_public_path__ + "img/accept-left-circle6.827dfb5f.svg";